import { render } from "./auth_callback.vue?vue&type=template&id=406525b8&scoped=true"
import script from "./auth_callback.vue?vue&type=script&lang=js"
export * from "./auth_callback.vue?vue&type=script&lang=js"

import "./auth_callback.vue?vue&type=style&index=0&id=406525b8&scoped=true&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406525b8"]])

export default __exports__